import {
  getCategoryIdFromItemId,
  getCategoryNameFromId,
  getSubcategoryIdFromItemId,
  getSubcategoryNameFromId,
} from "../../OnlineOrdering/Menu/helpers/getMenuData";

const getActiveCurrency = () => {
  let currencyCode = null;
  const skin = sessionStorage.getItem("merchantSkinName");

  if (sessionStorage.getItem(skin + "__merchantConfig")) {
    const merchantConfig = JSON.parse(sessionStorage.getItem(skin + "__merchantConfig")).merchant;
    currencyCode = merchantConfig.I34;
  }

  return currencyCode;
};

export const onPurchaseCompleteFB = (
  cartItems,
  orderSummary,
  orderStore,
  onlineOrderId,
  purchaseAdditionalInfo,
  orderMenu,
  manifestContext
) => {
  if (!window.fbq) {
    return;
  }
  let products = [];
  let totalValue = 0;
  cartItems.forEach((item) => {
    products.push({
      item_name: item.name,
      item_id: item.id,
      price: Number(item.price),
      item_category_id: item.category ? item.category : getCategoryIdFromItemId(item.id, orderMenu),
      item_subcategory_id: item.subcategory
        ? item.subcategory
        : getSubcategoryIdFromItemId(item.id, orderMenu),
      item_category: getCategoryNameFromId(item.category, orderMenu, item.id),
      item_subcategory: getSubcategoryNameFromId(item.subcategory, orderMenu, item.id),
      item_brand: manifestContext ? manifestContext.name : "",
      location_id: orderStore ? orderStore.storeId : "",
      affiliation: orderStore ? orderStore.name : "",
      quantity: item.quantity,
    });
    totalValue += Number(item.price) * (item.quantity || 1);
  });

  window.fbq("track", "Purchase", {
    transaction_id: onlineOrderId, // Transaction ID. Required for purchases and refunds.
    value: totalValue, // Total transaction value (not incl. tax and shipping)
    tax: Number(orderSummary.I4),
    currency: getActiveCurrency(),
    coupon: purchaseAdditionalInfo.coupon,
    items: products,
    total_discount: orderSummary.I2.discount_total,
    order_type: purchaseAdditionalInfo.orderType,
    discount: purchaseAdditionalInfo.promoCode,
    rewards: purchaseAdditionalInfo.rewards,
    tip: purchaseAdditionalInfo.tip,
    points_issued: purchaseAdditionalInfo.pointsIssued,
    affiliation: orderStore.name,
  });
};
